/**
 * Canonical seed event rows (mock DB). Used by the client timeline store and
 * server-side read APIs so both start from the same snapshot.
 */

import { getPublicDemoEvent } from "@/lib/demo/public-demo-event"
import type { EventData } from "@/lib/events/types"

/** Fresh mutable catalog — call when initializing stores (not per-request on hot path). */
export function createInitialEventsCatalog(): EventData[] {
  return [
    {
      id: "hosting_1",
      title: "Spring birthday dinner",
      date: "2026-03-04",
      location: "100 Harbor Way, Springfield",
      image:
        "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&h=800&fit=crop",
      description:
        "An evening of good food, music, and memories with friends and family.",
      hostName: "Demo Host",
      attendees: 27,
      isPublished: true,
      createdAt: new Date("2026-02-15"),
    },
    {
      id: "hosting_2",
      title: "Let's meet for BBQ",
      date: "2026-02-28",
      location: "100 Harbor Way, Springfield",
      image:
        "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&h=800&fit=crop",
      description: "Casual BBQ hangout with friends and family.",
      hostName: "Demo Host",
      attendees: 12,
      isPublished: true,
      createdAt: new Date("2026-02-10"),
    },
    {
      id: "hosting_3",
      title: "Farewell get-together",
      date: "2026-02-24",
      location: "200 River Road, Riverside",
      image:
        "https://images.unsplash.com/photo-1529543544277-750e9033193d?w=600&h=800&fit=crop",
      description: "One last hangout before a friend moves out of town.",
      hostName: "Demo Host",
      attendees: 18,
      isPublished: true,
      createdAt: new Date("2026-02-01"),
    },
    {
      id: "hosting_4",
      title: "Summer Gathering 2026",
      date: "2026-07-15",
      location: "Central Park, New York",
      image:
        "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=600&h=800&fit=crop",
      description: "Annual summer gathering with the crew.",
      hostName: "Demo Host",
      attendees: 45,
      isPublished: true,
      createdAt: new Date("2026-05-01"),
    },
    {
      id: "draft_1",
      title: "Kids birthday party",
      date: "2026-04-02",
      location: "Downtown community center",
      image:
        "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=600&h=800&fit=crop",
      description: "A fun afternoon celebration with games and cake.",
      hostName: "Demo Host",
      attendees: 0,
      isPublished: false,
      createdAt: new Date("2026-03-15"),
    },
    {
      id: "other_1",
      title: "Sarah's Graduation Party",
      date: "2026-05-20",
      location: "Boston, Massachusetts",
      image:
        "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&h=800&fit=crop",
      description: "Celebrating Sarah's MBA graduation!",
      hostName: "Sarah Chen",
      hostAvatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
      attendees: 65,
      isPublished: true,
      createdAt: new Date("2026-04-01"),
    },
    {
      id: "other_2",
      title: "Marcus & Tina Wedding",
      date: "2026-06-12",
      location: "Napa Valley, California",
      image:
        "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&h=800&fit=crop",
      description: "Join us as we celebrate the union of Marcus and Tina.",
      hostName: "Marcus Johnson",
      hostAvatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
      attendees: 120,
      isPublished: true,
      createdAt: new Date("2026-01-15"),
    },
    {
      id: "other_3",
      title: "Tech Meetup DC",
      date: "2026-04-18",
      location: "Washington DC",
      image:
        "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=800&fit=crop",
      description: "Monthly tech meetup for developers and designers.",
      hostName: "DC Tech Community",
      attendees: 89,
      isPublished: true,
      createdAt: new Date("2026-03-01"),
    },
    {
      id: "other_4",
      title: "Jazz Night at Blue Note",
      date: "2026-04-25",
      location: "Blue Note Jazz Club, NYC",
      image:
        "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&h=800&fit=crop",
      description: "An evening of smooth jazz and good vibes.",
      hostName: "Blue Note Events",
      attendees: 150,
      isPublished: true,
      createdAt: new Date("2026-03-20"),
    },
    {
      id: "other_5",
      title: "Yoga Retreat Weekend",
      date: "2026-05-08",
      location: "Sedona, Arizona",
      image:
        "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=600&h=800&fit=crop",
      description: "A weekend of mindfulness and rejuvenation.",
      hostName: "Mindful Living Co",
      attendees: 30,
      isPublished: true,
      createdAt: new Date("2026-02-28"),
    },
    getPublicDemoEvent(),
  ]
}
